/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { RideEvent } from 'src/app/models/ride-event';
import {
    CreateRideEvent,
    DeleteRideEvent,
    ForceEventsRefresh,
    RideEventAction,
    SetActiveRideEvent,
    SetPublicRideEvents,
    SetRideEvents,
    UpdateRideEvent,
} from './ride-event.actions';

export interface RideEventState {
    rideEvents: RideEvent[];
    forceRefresh: boolean;
    publicRideEvents: RideEvent[];
    activeRideEvent?: RideEvent;
}

const reducerMap: ActionReducerMap<RideEventState> = {
    activeRideEvent: activeRideEventReducer,
    forceRefresh: forceRefreshReducer,
    publicRideEvents: publicRideEventsReducer,
    rideEvents: rideEventsReducer,
};

export const selectRideEventState =
    createFeatureSelector<RideEventState>('rideEvent');
export const selectRideEvents = createSelector(
    selectRideEventState,
    (state) => state.rideEvents
);
export const selectPublicRideEvents = createSelector(
    selectRideEventState,
    (state) => state.publicRideEvents
);
export const selectActiveRideEvent = createSelector(
    selectRideEventState,
    (state) => state.activeRideEvent
);
export const selectShouldForceEventsRefresh = createSelector(
    selectRideEventState,
    (state) => state.forceRefresh
);
export const rideEventStoreModule = StoreModule.forFeature(
    'rideEvent',
    reducerMap
);

function rideEventsReducer(state: RideEvent[] = [], action: Action) {
    switch (action.type) {
        case RideEventAction.createRideEvent:
            return [...state, (action as CreateRideEvent).rideEvent];
        case RideEventAction.deleteRideEvent:
            return state.filter(
                (rideEvent) =>
                    rideEvent.id !== (action as DeleteRideEvent).rideEventId
            );
        case RideEventAction.setRideEvents:
            return (action as SetRideEvents).rideEvents;
        case RideEventAction.updateRideEvent:
            return [
                ...state.filter(
                    (rideEvent) =>
                        rideEvent.id !==
                        (action as UpdateRideEvent).rideEvent.id
                ),
                (action as UpdateRideEvent).rideEvent,
            ];

        default:
            return state;
    }
}

function publicRideEventsReducer(state = [], action: Action) {
    switch (action.type) {
        case RideEventAction.setPublicRideEvents:
            return (action as SetPublicRideEvents).rideEvents;
        default:
            return state;
    }
}

function activeRideEventReducer(state: RideEvent, action: Action) {
    switch (action.type) {
        case RideEventAction.setActiveRideEvent:
            return (action as SetActiveRideEvent).rideEvent?.clone();
        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case RideEventAction.forceEventsRefresh:
            return (action as ForceEventsRefresh).forceRefresh;
        default:
            return state;
    }
}
